/*!
 * © 2026 Soulcute / Tailoring Consult — Todos los derechos reservados.
 */
/* Cart Rewards v3 (2026-08-28):
   — Removido interceptor XMLHttpRequest
   — Fetch interceptor con try/catch
   — console.log minimizados
   — NUEVO: muestra ahorro al lado del badge del regalo ($15.990 tachado + GRATIS)
*/
(function(){
  var cfg=window.scRewardsCfg;
  if(!cfg)return;
  var GP=cfg.giftProperty||'_sc_gift';
  var syncing=false;

  function cartSubtotalWithoutGifts(cart){
    var sub=0;
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p[GP])return;
      sub+=(it.final_line_price!=null?it.final_line_price:it.line_price);
    });
    return sub;
  }

  function findGiftLine(cart,handle){
    return (cart.items||[]).find(function(it){
      var p=it.properties||{};
      return it.handle===handle&&p[GP];
    });
  }

  function addGift(variantId){
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id:variantId,quantity:1,properties:{[GP]:'true'}}]})
    }).then(function(r){triggerCartRefresh();return r;});
  }

  function triggerCartRefresh(){
    setTimeout(function(){
      try {
        document.dispatchEvent(new CustomEvent('cart:update',{
          bubbles:true,
          detail:{resource:{},data:{source:'sc-rewards',sections:{}}}
        }));
      } catch(e) {}
    },150);
  }

  function pickGiftVariantBySize(cart, giftCfg){
    if(!giftCfg.variants || !giftCfg.variants.length) return giftCfg.variantId;
    var counts={};
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p[GP]) return;
      var opts=it.options_with_values||[];
      opts.forEach(function(o){
        var name=(o.name||'').toLowerCase();
        if(name==='talla'||name==='size'){
          var v=String(o.value||'').toUpperCase();
          counts[v]=(counts[v]||0)+1;
        }
      });
    });
    var topSize=null,topCount=0;
    for(var k in counts){if(counts[k]>topCount){topCount=counts[k];topSize=k;}}
    if(!topSize) return giftCfg.variantId;
    var match=giftCfg.variants.find(function(v){return String(v.title).toUpperCase()===topSize});
    return match?match.id:giftCfg.variantId;
  }

  var _stockCache={};
  function realProductStock(handle){
    if(!handle) return Promise.resolve({has:true,bySize:{},price:0});
    var c=_stockCache[handle];
    if(c && (Date.now()-c.ts)<30000) return Promise.resolve(c.value);
    return fetch('/products/'+handle+'.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(product){
        var bySize={};
        (product.variants||[]).forEach(function(v){
          var size=null;
          if(v.options&&v.options.length){
            size=String(v.options[v.options.length-1]).toUpperCase();
          } else if(v.title){
            size=String(v.title).toUpperCase();
          }
          if(size)bySize[size]=v.available===true;
        });
        var has=Object.keys(bySize).some(function(k){return bySize[k]});
        /* Precio (Shopify devuelve en cents-style: $15.990 = 1599000) */
        var price=(product.price!=null?product.price:(product.variants&&product.variants[0]?product.variants[0].price:0))||0;
        var res={has:has,bySize:bySize,price:price};
        _stockCache[handle]={ts:Date.now(),value:res};
        return res;
      })
      .catch(function(){return {has:true,bySize:{},price:0}});
  }
  function realProductHasStock(handle){
    return realProductStock(handle).then(function(r){return r.has});
  }
  function realProductPrice(handle){
    return realProductStock(handle).then(function(r){return r.price});
  }

  /* Formatea CLP desde cents-style. 1599000 → "$15.990" */
  function formatCLP(cents){
    if(!cents||cents<=0)return '';
    var amount=Math.round(cents/100);
    return '$'+amount.toLocaleString('es-CL');
  }

  function removeGiftLine(key){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({id:key,quantity:0})
    }).then(function(r){triggerCartRefresh();return r;});
  }

  function capGiftQuantity(key){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({id:key,quantity:1})
    }).then(function(r){triggerCartRefresh();return r;});
  }

  var _sizeChangeLock=false;

  function syncOnce(){
    if(syncing||_sizeChangeLock) return Promise.resolve();
    syncing=true;
    return fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(cart){
        var sub=cartSubtotalWithoutGifts(cart);
        var promises=[];
        ['gift1','gift2'].forEach(function(key){
          var g=cfg[key];
          if(!g||!g.enabled) return;
          if(!g.variantId) return;
          if(!g.handle) return;
          var existing=findGiftLine(cart,g.handle);
          var shouldHave=sub>=g.threshold;
          var allLines=(cart.items||[]).filter(function(it){
            var p=it.properties||{};
            return it.handle===g.handle&&p[GP];
          });
          if(allLines.length>1){
            allLines.slice(1).forEach(function(extra){
              promises.push(removeGiftLine(extra.key).catch(function(){}));
            });
          }
          if(shouldHave&&!existing){
            promises.push(realProductHasStock(g.realProductHandle).then(function(hasStock){
              if(!hasStock) return;
              var vid=(key==='gift1')?pickGiftVariantBySize(cart,g):g.variantId;
              return addGift(vid).then(function(r){return r.json()}).catch(function(){});
            }));
          }else if(!shouldHave&&existing){
            promises.push(removeGiftLine(existing.key).catch(function(){}));
          }else if(shouldHave&&existing&&existing.quantity>1){
            promises.push(capGiftQuantity(existing.key).catch(function(){}));
          }
        });
        return Promise.all(promises);
      })
      .then(function(){ syncing=false; })
      .catch(function(){ syncing=false; });
  }

  function injectGiftStyles(){
    if(document.getElementById('sc-gift-lock-styles'))return;
    var s=document.createElement('style');
    s.id='sc-gift-lock-styles';
    s.textContent=[
      '.sc-is-gift { position:relative; }',
      '.sc-is-gift quantity-input,',
      '.sc-is-gift .quantity,',
      '.sc-is-gift .quantity-selector,',
      '.sc-is-gift [name="updates[]"],',
      '.sc-is-gift button[name="minus"],',
      '.sc-is-gift button[name="plus"],',
      '.sc-is-gift button[name="decrease"],',
      '.sc-is-gift button[name="increase"],',
      '.sc-is-gift [data-quantity-decrease],',
      '.sc-is-gift [data-quantity-increase],',
      '.sc-is-gift cart-remove-button,',
      '.sc-is-gift [data-line-item-remove],',
      '.sc-is-gift button[aria-label*="remove" i],',
      '.sc-is-gift button[aria-label*="quitar" i],',
      '.sc-is-gift button[aria-label*="eliminar" i],',
      '.sc-is-gift button[aria-label*="delete" i],',
      '.sc-is-gift .cart-item__quantity-wrapper,',
      '.sc-is-gift .cart-item__quantity { display:none !important; visibility:hidden !important }',
      '.sc-gift-meta { display:inline-flex; flex-wrap:wrap; align-items:center; gap:8px; margin-top:6px; }',
      '.sc-gift-badge { display:inline-flex; align-items:center; gap:4px; font-size:11px; font-weight:700; color:#fff; background:linear-gradient(135deg,#E91E63 0%,#6B031E 100%); padding:4px 10px; border-radius:14px; letter-spacing:.02em; text-transform:uppercase; box-shadow:0 1px 3px rgba(107,3,30,.2); line-height:1; }',
      /* NUEVO: savings badge (precio tachado + GRATIS) */
      '.sc-gift-savings { display:inline-flex; align-items:center; gap:5px; font-size:12px; line-height:1; }',
      '.sc-gift-savings-was { color:#B58A97; text-decoration:line-through; font-weight:600; font-size:12px; }',
      '.sc-gift-savings-now { color:#0a7d2b; font-weight:800; letter-spacing:.03em; font-size:12px; }',
      '.sc-gift-size-selector { display:inline-flex; align-items:center; gap:6px; font-size:13px; color:#6B031E; font-family:inherit; }',
      '.sc-gift-size-selector__label { font-size:12px; font-weight:600; color:#666; }',
      '.sc-gift-size-selector select { appearance:none; -webkit-appearance:none; padding:5px 26px 5px 10px; border:1.5px solid #D8A7B1; border-radius:6px; background:#fff url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 12 12\' fill=\'%236B031E\'%3e%3cpath d=\'M2 4l4 4 4-4\' stroke=\'%236B031E\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3e%3c/svg%3e") no-repeat right 8px center; background-size:10px; color:#6B031E; font-weight:700; cursor:pointer; min-width:70px; font-size:13px; line-height:1.2; transition:all .15s ease; }',
      '.sc-gift-size-selector select:hover { border-color:#6B031E; }',
      '.sc-gift-size-selector select:disabled { opacity:.5; cursor:wait; }',
      '.sc-gift-size-selector select:focus { outline:none; border-color:#6B031E; box-shadow:0 0 0 3px rgba(107,3,30,.12); }',
      '.sc-is-gift .cart-items__unit-price-wrapper,',
      '.sc-is-gift .cart-item__price-wrapper,',
      '.sc-is-gift .cart-item__details .cart-item__price,',
      '.sc-is-gift .cart-item__info .cart-item__price { display:none !important; visibility:hidden !important; }',
      '.sc-is-gift td:has(.cart-items__unit-price-wrapper) { padding:0 !important; }',
      '.sc-is-gift .cart-items__line-price,',
      '.sc-is-gift .cart-item__line-price,',
      '.sc-is-gift [class*="line-price"] { color:#E91E63 !important; font-weight:700 !important; }',
      'cart-drawer-component dialog::backdrop { background:transparent !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }',
      'dialog.cart-drawer__dialog::backdrop { background:transparent !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }',
      'cart-drawer-component dialog.cart-drawer__dialog { box-shadow:-8px 0 32px rgba(107,3,30,.18) !important; }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function tagGiftLines(){
    injectGiftStyles();
    var giftVids=[];
    var giftVidToCfg={};
    if(cfg.gift1){
      if(cfg.gift1.variants&&cfg.gift1.variants.length){
        cfg.gift1.variants.forEach(function(v){
          giftVids.push(String(v.id));
          giftVidToCfg[String(v.id)]={key:'gift1',cfg:cfg.gift1,size:v.title};
        });
      }else if(cfg.gift1.variantId){
        giftVids.push(String(cfg.gift1.variantId));
        giftVidToCfg[String(cfg.gift1.variantId)]={key:'gift1',cfg:cfg.gift1,size:null};
      }
    }
    if(cfg.gift2&&cfg.gift2.variantId){
      giftVids.push(String(cfg.gift2.variantId));
      giftVidToCfg[String(cfg.gift2.variantId)]={key:'gift2',cfg:cfg.gift2,size:null};
    }
    if(!giftVids.length)return;

    document.querySelectorAll('[data-variant-id]').forEach(function(el){
      var vid=String(el.dataset.variantId);
      if(giftVids.indexOf(vid)<0)return;
      var row=el.closest('cart-items-component li, cart-items-component tr, [data-line-item], .cart-item, [class*="cart-item__row"], li[id*="CartItem"]')||el.parentElement;
      if(!row||row.classList.contains('sc-is-gift'))return;
      row.classList.add('sc-is-gift');
      var info=giftVidToCfg[vid];
      injectGiftMeta(row,info,el);
    });
  }

  function injectGiftMeta(row,info,variantEl){
    if(row.querySelector('.sc-gift-meta'))return;
    var meta=document.createElement('div');
    meta.className='sc-gift-meta';

    /* Badge "Regalo gratis" */
    var badge=document.createElement('span');
    badge.className='sc-gift-badge';
    badge.innerHTML='\u{1F381} Regalo gratis';
    meta.appendChild(badge);

    /* NUEVO: mostrar ahorro (precio tachado + GRATIS) */
    if(info.cfg&&info.cfg.realProductHandle){
      var savings=document.createElement('span');
      savings.className='sc-gift-savings';
      savings.innerHTML='<span class="sc-gift-savings-loading" style="color:#B58A97;font-size:11px;">calculando...</span>';
      meta.appendChild(savings);

      realProductPrice(info.cfg.realProductHandle).then(function(price){
        if(price>0){
          var formatted=formatCLP(price);
          savings.innerHTML='<span class="sc-gift-savings-was">'+formatted+'</span><span class="sc-gift-savings-now">GRATIS</span>';
        }else{
          savings.remove();
        }
      }).catch(function(){ savings.remove(); });
    }

    /* Dropdown de cambio de talla (solo gift1 con tallas) */
    if(info.key==='gift1'&&info.cfg.variants&&info.cfg.variants.length>1){
      var sel=buildSizeSelector(info.cfg,info.size);
      meta.appendChild(sel);
    }

    var insertTarget=row.querySelector('.cart-item__details, .cart-item__info, .cart-item__media')||row;
    insertTarget.appendChild(meta);
  }

  function buildSizeSelector(giftCfg,currentSize){
    var wrap=document.createElement('span');
    wrap.className='sc-gift-size-selector';
    var lbl=document.createElement('span');
    lbl.className='sc-gift-size-selector__label';
    lbl.textContent='Talla:';
    var sel=document.createElement('select');
    sel.setAttribute('autocomplete','off');
    var loading=document.createElement('option');
    loading.textContent='...';loading.disabled=true;loading.selected=true;
    sel.appendChild(loading);

    realProductStock(giftCfg.realProductHandle).then(function(stock){
      sel.innerHTML='';
      var available=giftCfg.variants.filter(function(v){
        var sz=String(v.title).toUpperCase();
        return stock.bySize[sz]===true;
      });
      var list=available.length?available:giftCfg.variants;
      list.forEach(function(v){
        var opt=document.createElement('option');
        opt.value=v.id;
        opt.textContent=v.title;
        if(String(v.title).toUpperCase()===String(currentSize||'').toUpperCase())opt.selected=true;
        sel.appendChild(opt);
      });
    });
    sel.addEventListener('change',function(){
      var newVid=parseInt(sel.value);
      if(!newVid)return;

      _sizeChangeLock=true;
      sel.disabled=true;
      var row=sel.closest('.sc-is-gift');
      var badge=row?row.querySelector('.sc-gift-badge'):null;
      var originalBadge=badge?badge.innerHTML:'';
      if(badge)badge.innerHTML='\u{1F504} Actualizando...';

      function releaseLock(){
        _sizeChangeLock=false;
        sel.disabled=false;
        if(badge)badge.innerHTML=originalBadge;
      }

      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
        var allGiftLines=(cart.items||[]).filter(function(it){
          var p=it.properties||{};
          return it.handle===giftCfg.handle&&p[GP];
        });
        if(!allGiftLines.length){
          return addGift(newVid).then(function(){setTimeout(releaseLock,600);});
        }
        var chain=Promise.resolve();
        allGiftLines.forEach(function(line){chain=chain.then(function(){return removeGiftLine(line.key)});});
        return chain.then(function(){return addGift(newVid);}).then(function(){
          setTimeout(releaseLock,600);
        });
      }).catch(function(){releaseLock();});
    });
    wrap.appendChild(lbl);
    wrap.appendChild(sel);
    return wrap;
  }

  var giftTagObserver=null;
  function startGiftTagObserver(){
    if(giftTagObserver)return;
    try {
      giftTagObserver=new MutationObserver(function(){tagGiftLines()});
      giftTagObserver.observe(document.body,{childList:true,subtree:true});
    } catch(e) {}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){tagGiftLines();startGiftTagObserver()});
  }else{
    tagGiftLines();startGiftTagObserver();
  }

  /* UNIFIED FETCH INTERCEPTOR con try/catch */
  try {
    var origFetch = window.fetch;
    window.fetch = function(){
      var args = arguments;
      var url = args[0];
      var promise;
      try {
        promise = origFetch.apply(this, args);
      } catch(e) {
        return Promise.reject(e);
      }
      try {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          promise.then(function(){ setTimeout(syncAndMaybeReload, 400); }).catch(function(){});
        }
      } catch(e) {}
      return promise;
    };
  } catch(e) {}

  try {
    ['cart:updated','cart:added','cart:changed','cart:item-added','cart:refresh','variant:add'].forEach(function(ev){
      document.addEventListener(ev,function(){setTimeout(syncAndMaybeReload,400)});
      window.addEventListener(ev,function(){setTimeout(syncAndMaybeReload,400)});
    });
  } catch(e) {}

  setInterval(function(){
    if(document.visibilityState==='visible'&&!syncing){
      syncAndMaybeReload();
    }
  },5000);

  var lastSubtotal=null;
  function syncAndMaybeReload(){
    var oldSub=lastSubtotal;
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(cart){
        var sub=cartSubtotalWithoutGifts(cart);
        var crossedThreshold=false;
        if(oldSub!==null){
          ['gift1','gift2'].forEach(function(key){
            var g=cfg[key];
            if(!g||!g.enabled)return;
            var was=oldSub>=g.threshold;
            var now=sub>=g.threshold;
            if(was!==now)crossedThreshold=true;
          });
        }
        lastSubtotal=sub;
        return syncOnce().then(function(){
          if(crossedThreshold&&window.location.pathname==='/cart'){
            window.location.reload();
          }
        });
      })
      .catch(function(){});
  }

  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
    lastSubtotal=cartSubtotalWithoutGifts(cart);
    syncOnce();
  }).catch(function(){});
})();
